import getScrollTargetPath from './scroll-target-path';

const selectors = {
  getScrollTargetPath,
};

export default selectors;
